export const RoutineReducerInitialState = {
  routinesById: {}
};
